import { SVGProps } from 'react';

export const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="10" height="8" viewBox="0 0 10 8" className="fill-white" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 4.73438L8.29688 0.4375L9.70312 1.85938L4 7.5625L0.296875 3.85938L1.70312 2.4375L4 4.73438Z" />
  </svg>
);
